import {VideoDurationTag} from '../../../../../../../../component/video-duration-tag/video-duration-tag';
import {isCompanyGalleryVideo} from '../../../../../../../../service/company-v2/types/company-gallery-type';
import {
    CompanyImageFormType,
    CompanyVideoFormType,
} from '../../../../../../../../service/company-v2/types/company-logo-type';

import * as styles from './gallery-image.scss';

type PropsType = {
    media: CompanyImageFormType | CompanyVideoFormType;
};

export function GalleryVideoDuration(props: PropsType): JSX.Element | null {
    const {media} = props;
    const durationSec = isCompanyGalleryVideo(media) ? media.durationSec : null;

    if (!durationSec) {
        return null;
    }

    return (
        <div className={styles.InputImage_duration}>
            <VideoDurationTag durationMillis={Math.round(durationSec) * 1000} rightBottomCorned={false} />
        </div>
    );
}
